/** Vibecode authoring notes for `stack` nodes (empty = omit from LLM bundle). */
export const STACK_VIBECODE =
  '`stack`: `variant` compact|default|loose (vertical gap); numeric `gap` overrides.';
